import { useNavigate } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import {
  case_completed,
  case_submitted,
  case_pending,
  documenticon,
  imagesend,
  mascot_img_main,
  case_rush,
} from '../../imagepath';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import BreadCrumbs from '../../core/BreadCrumbs';
import { Button
  // , Flex, Typography
 } from 'antd'; //Select
import { useDashboard } from '../../../hooks/dashboard/useDashboard';
import { useUserProfile } from '../../../hooks/useUserProfile';
import { useUserSelectedBranchLocation } from '../../../hooks/useUserSelectedBranchLocation';
import { hasModuleAccess, UserModules } from '../../../authguard/routes';
// const { Text } = Typography;

const BREAD_CRUMBS = [{ label: 'Dashboard', to: '/user/admin-dashboard' }];

const DashboardStatCard = ({
  icon,
  title,
  count = 0,
  onViewAll,
  extraContent,
}) => {
  const titleText = typeof title === 'string' ? title : 'Dashboard stat';

  return (
    <div className="col-md-3 col-sm-6 col-lg-2 col-xl-2 mb-3 d-flex">
      <div className="dash-widget w-100 d-flex flex-column">
        <div className="dash-boxs comman-flex-center">
          <img src={icon} alt={titleText} />
        </div>
        <div className="dash-content dash-count d-flex flex-column flex-grow-1 gap-3">
          <div className="d-flex flex-column gap-2">
            <h4 className="mb-0">{title}</h4>
            <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
              <h2 className="mb-0">
                <CountUp delay={0.4} end={count || 0} duration={0.6} />
              </h2>
              {extraContent}
            </div>
          </div>
          {onViewAll ? <Button
            size="small"
            type="link"
            className="p-0 mt-auto"
            onClick={onViewAll}
          >
            View All
          </Button> : null}
        </div>
      </div>
    </div>
  );
};

DashboardStatCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onViewAll: PropTypes.func.isRequired,
  extraContent: PropTypes.node,
};

const Admin_Dashboard = () => {
  const { userProfile } = useUserProfile();
  const { selectedLocation } = useUserSelectedBranchLocation();
  const navigate = useNavigate();

  const { data } = useDashboard();

  const caseCards = [
    {
      key: 'pending',
      title: (<>Pending <br />Cases</>),
      icon: case_pending,
      count: data?.caseStatistics?.pendingCases,
      onViewAll: () => navigate('/user/case/created'),
    },
    {
      key: 'submitted',
      title: (<>Submitted <br />Cases</>),
      icon: case_submitted,
      count: data?.caseStatistics?.submittedCases,
      onViewAll: () => navigate('/user/case/submitted'),
    },
    {
      key: 'rush',
      title: (
        <>
          Rush <br /> Cases
        </>
      ),
      icon: case_rush,
      count: data?.caseStatistics?.rushCases,
      onViewAll: () =>
        navigate('/user/case/submitted?sort=hasRush:descend&rushOnly=1'),
    },
    {
      key: 'completed',
      title: (<>Completed <br />Cases</>),
      icon: case_completed,
      count: data?.caseStatistics?.completedCases,
      onViewAll: () => navigate('/user/case/completed'),
    },
  ];

  return (
    <div>
      <BreadCrumbs items={BREAD_CRUMBS} />
      <div className="good-morning-blk">
        <div className="row">
          <div className="col-md-6 col-lg-8 col-xl-8">
            <div className="morning-user">
              <h2>
                Good Morning, <span>{userProfile?.fullName}</span>
              </h2>
              <p>Have a nice day at work</p>
              <p>
                <small>(Below data is for the current month only!)</small>
              </p>
              <Button
                className="mt-4"
                type="primary"
                size="large"
                onClick={() => navigate('/user/case/add')}
              >
                New Case
              </Button>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-xl-4 position-blk">
            <div className="morning-img">
              <img src={mascot_img_main} alt="#" height={150} width={150} />
            </div>
          </div>
        </div>
      </div>
      <div className="row g-3">
        {hasModuleAccess(UserModules.CASE, selectedLocation?.modules || []) && (
          <>
            {caseCards.map((card) => (
              <DashboardStatCard
                key={card.key}
                icon={card.icon}
                title={card.title}
                count={card.count}
                onViewAll={card.onViewAll}
              />
            ))}
          </>
        )}
        {/* Account Modules */}
        {hasModuleAccess(UserModules.ACCOUNT, selectedLocation?.modules || []) && (
          <DashboardStatCard
            icon={documenticon}
            title="Invoices"
            count={data?.invoiceStatistics?.invoicesCount}
            // onViewAll={() => navigate('/user/invoicelist')}
            // extraContent={
            //   <Flex align="center" gap={4}>
            //     <Text className="mb-0">Value:</Text>
            //     <Text strong className="mb-0">
            //       $
            //       <CountUp
            //         delay={0.4}
            //         end={data?.invoiceStatistics?.invoicesValue || 0}
            //         duration={0.6}
            //       />
            //     </Text>
            //   </Flex>
            // }
          />
        )}
      </div>
      <div id="delete_patient" className="modal fade delete-modal" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src={imagesend} alt="#" width={50} height={46} />
              <h3>Are you sure want to delete this?</h3>
              <div className="m-t-20">
                <Link
                  to="#"
                  className="btn btn-white me-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </Link>
                <button type="submit" className="btn btn-danger">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin_Dashboard;
